export const zones = [
    {
        bgColor: "#9d1516",
        text: [
            {
                title: "Presentation zone",
                subtitle: "Ovo nije",
                text: "Ovo je mesto gde je neko prvi put izložio svoje radove. I talenat pretvorio u uspešnu budućnost.",
            },
            {
                title: "Moderno uređeno i prostrano prizemlje",
                text: <>Prostor Savremene gimnazije nalazi se u prizemlju Beograđanke i koncipiran je kao otvoreni prostor za prezentaciju školskih aktivnosti.<br /><br /> Prostor saglediv sa ulice, sa tipskim izložbenim postamentima za privremene izložbe i prezentacije, daje priliku učenicima da predstave svoje projekte, ideje i postignuća.</>,
                list: ["88 m²", "aktivna zona", "kolektivno"]
            },
        ],
    },
];